function patch_activateCardsSection(header) {
	if (header) {
		var toggle = document.createElement('p'),
			parent = header.parentNode,
			showClass = 'CardsSection--show',
			showText = "View " + icons.show,
			hideText = "Close " + icons.hide;
		toggle.className = 'CardsSection-toggle';
		toggle.innerHTML = (parent.classList.contains(showClass)) ? hideText : showText;

		header.appendChild(toggle);
		header.addEventListener('click', function(e) {
			e.preventDefault();
			var toggle = this.querySelector('.CardsSection-toggle'),
				parent = header.parentNode;

			if (parent.classList.contains(showClass)) {
				parent.classList.remove(showClass);
				toggle.innerHTML = showText;
			} else {
				parent.classList.add(showClass);
				toggle.innerHTML = hideText;
			}
		});
	}
}

document.addEventListener('DOMContentLoaded', function() {

	var sections = document.getElementsByClassName('CardsSection'),
		header = null;
	if (sections) {
		for (var i = 0, l = sections.length; i < l; i++) {
			patch_activateCardsSection(sections[i].querySelector('.CardsSection-header'));
		}
	}

});
